import React from 'react';
import CustomerModal from '../../CustomerModal';

const CustomerSelectModal = ({
  show,
  onClose,
  customerSearch,
  onSearchChange,
  filteredCustomers,
  onSelectCustomer,
  onOpenAddCustomer,
  showAddCustomerModal,
  onCloseAddCustomer,
  onAddNewCustomer,
}) => (
  <>
    {show && (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1060,
      }}>
        <div style={{
          backgroundColor: 'var(--card-bg)',
          borderRadius: '8px',
          maxWidth: '700px',
          width: '95%',
          maxHeight: '85vh',
          overflow: 'hidden',
          boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
        }}>
          <div style={{
            background: 'linear-gradient(135deg, var(--info) 0%, var(--info) 100%)',
            color: '#fff' ,
            padding: '0.5rem 0.75rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
            <h3 style={{ margin: 0, fontSize: '12px', fontWeight: '600' }}>
              &#x1F465; Wybierz odbiorc&#x119; WZ
            </h3>
            <button
              onClick={onClose}
              style={{
                padding: '4px 10px',
                backgroundColor: 'var(--bg-secondary)',
                color: 'var(--text)',
                border: '1px solid var(--border)',
                cursor: 'pointer',
                fontSize: '11px',
              }}
            >
              &#x2715;
            </button>
          </div>

          <div style={{ padding: '0.5rem' }}>
            <div style={{ display: 'flex', gap: '6px', marginBottom: '0.5rem' }}>
              <input
                type="text"
                placeholder="Szukaj klienta (nazwa, NIP, email)..."
                value={customerSearch}
                onChange={(e) => onSearchChange(e.target.value)}
                autoFocus
                style={{
                  flex: 1,
                  padding: '6px 10px',
                  fontSize: '12px',
                  border: '1px solid var(--border)',
                  borderRadius: '6px',
                  backgroundColor: 'var(--card-bg)',
                  color: 'var(--text)',
                }}
              />
              <button
                type="button"
                onClick={onOpenAddCustomer}
                style={{
                  padding: '6px 12px',
                  fontSize: '12px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  border: '1px solid var(--success)', color: 'var(--success)' ,
                }}
              >
                &#x2795; Dodaj nowego
              </button>
            </div>

            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
              {filteredCustomers.length === 0 ? (
                <div style={{ padding: '1.5rem', textAlign: 'center', color: 'var(--text-muted)', fontSize: '11px' }}>
                  <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>&#x1F4ED;</div>
                  <p style={{ margin: 0 }}>Brak klient&#xF3;w do wy&#x15B;wietlenia</p>
                  {customerSearch && (
                    <button
                      onClick={onOpenAddCustomer}
                      style={{
                        marginTop: '0.5rem',
                        padding: '4px 10px',
                        fontSize: '11px',
                        border: '1px solid var(--success)',
                        cursor: 'pointer',
                        backgroundColor: 'var(--card-bg)',
                        color: 'var(--success)',
                      }}
                    >
                      &#x2795; Dodaj nowego klienta
                    </button>
                  )}
                </div>
              ) : (
                <div>
                  {filteredCustomers.map((customer, index) => (
                    <div
                      key={customer.id}
                      onClick={() => onSelectCustomer(customer)}
                      style={{
                        padding: '0.5rem',
                        backgroundColor: index % 2 === 0 ? 'var(--card-bg)' : 'var(--bg)',
                        borderBottom: '1px solid var(--border)',
                        cursor: 'pointer',
                        fontSize: '10px',
                        transition: 'background-color 0.2s',
                      }}
                      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'var(--info-light)')}
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor =
                          index % 2 === 0 ? 'var(--card-bg)' : 'var(--bg)')
                      }
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                        <div>
                          <div style={{ fontWeight: '600', marginBottom: '2px', fontSize: '11px' }}>
                            {customer.nazwa_firmy ||
                              `${customer.imie || ''} ${customer.nazwisko || ''}`.trim() ||
                              'Bez nazwy'}
                          </div>
                          {customer.nip && (
                            <div style={{ color: 'var(--info)', fontSize: '9px' }}>NIP: {customer.nip}</div>
                          )}
                          {customer.email && (
                            <div style={{ color: 'var(--text-muted)', fontSize: '9px' }}>
                              &#x1F4E7; {customer.email}
                            </div>
                          )}
                          {(customer.telefon || customer.phone) && (
                            <div style={{ color: 'var(--text-muted)', fontSize: '9px' }}>
                              &#x1F4DE; {customer.telefon || customer.phone}
                            </div>
                          )}
                          {(customer.adres || customer.miasto) && (
                            <div style={{ color: 'var(--text-muted)', fontSize: '9px' }}>
                              &#x1F4CD;{' '}
                              {[customer.adres, customer.kod_pocztowy, customer.miasto]
                                .filter(Boolean)
                                .join(', ')}
                            </div>
                          )}
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '2px' }}>
                          <span style={{
                            fontSize: '9px',
                            color: customer.typ_klienta === 'firma' ? 'var(--info)' : 'var(--text-muted)',
                            padding: '2px 4px',
                            backgroundColor: customer.typ_klienta === 'firma' ? 'var(--info-light)' : 'var(--border)',
                            borderRadius: '3px',
                          }}>
                            {customer.typ_klienta === 'firma' ? '🏢 Firma' : '👤 Osoba'}
                          </span>
                          <span style={{ fontSize: '8px', color: 'var(--text-muted)' }}>ID: {customer.id}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )}

    <CustomerModal
      isOpen={showAddCustomerModal}
      onClose={onCloseAddCustomer}
      onSuccess={onAddNewCustomer}
    />
  </>
);

export default CustomerSelectModal;
